/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Icon';

/**
 * @deprecated since version 20.2.0. Please use the new Glyph component. You can read more about it in the prisma-design-system storybook under iconography/glyphs.
 */
const BrandEd: any = ({ color, size = 'medium', ...props }) => {
  return (
    // @ts-expect-error TODO: Fix viewBox type in next ticket OF2-3365
    <Icon viewBox="0 0 24 24" size={size} color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.516 16.235c.727 0 1.315.56 1.315 1.25v1.14c0 .689-.588 1.25-1.315 1.25H1.314C.59 19.874 0 19.313 0 18.624v-1.14c0-.69.59-1.25 1.314-1.25h1.202zm5.898-3.112c.907 0 1.642.7 1.642 1.56v1.907c0 .861-.735 1.561-1.642 1.561H6.406c-.907 0-1.643-.7-1.643-1.561v-1.906c0-.862.736-1.561 1.643-1.561h2.008zM22.356 4C23.264 4 24 4.7 24 5.562v8.587c0 .862-.736 1.56-1.644 1.56h-9.04c-.908 0-1.644-.698-1.644-1.56V5.562c0-.862.736-1.562 1.643-1.562h9.041z"
        fill="#005DAD"
      />
    </Icon>
  );
};

export default BrandEd;

BrandEd.propTypes = {
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
